import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useAuth } from './lib/auth'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Today from './pages/Today'
import Users from './pages/Users'
import Invites from './pages/Invites'
import Tickets from './pages/Tickets'
import Conversions from './pages/Conversions'
import Leads from './pages/Leads'
import Prospects from './pages/Prospects'
import Emails from './pages/Emails'
import Downloads from './pages/Downloads'
import Analytics from './pages/Analytics'
import Funnel from './pages/Funnel'
import Crashes from './pages/Crashes'
import Archives from './pages/Archives'
import Subscriptions from './pages/Subscriptions'
import Marketplace from './pages/Marketplace'
import Organizations from './pages/Organizations'
import AI from './pages/AI'
import Meetings from './pages/Meetings'
import Conversations from './pages/Conversations'
import AuditLog from './pages/AuditLog'

function RequireAuth({ children }: { children: JSX.Element }) {
  const session = useAuth()
  const location = useLocation()
  if (!session) return <Navigate to="/login" state={{ from: location }} replace />
  return children
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="today" element={<Today />} />
        <Route path="users" element={<Users />} />
        <Route path="archives" element={<Archives />} />
        <Route path="invites" element={<Invites />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="conversions" element={<Conversions />} />
        <Route path="leads" element={<Leads />} />
        <Route path="prospects" element={<Prospects />} />
        <Route path="emails" element={<Emails />} />
        <Route path="downloads" element={<Downloads />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="funnel" element={<Funnel />} />
        <Route path="crashes" element={<Crashes />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="marketplace" element={<Marketplace />} />
        <Route path="organizations" element={<Organizations />} />
        <Route path="ai" element={<AI />} />
        <Route path="meetings" element={<Meetings />} />
        <Route path="conversations" element={<Conversations />} />
        <Route path="audit" element={<AuditLog />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
